import { api } from "./api";
import { detectDevice } from "../hooks/useInstallPrompt";

const ID_KEY = "ishukart_device_id";
const INSTALL_KEY = "ishukart_install_reported";

// Anonymous per-device id (no personal data) so installs count once per phone/computer.
const deviceId = () => {
  let id = localStorage.getItem(ID_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem(ID_KEY, id);
  }
  return id;
};

export const trackAppTap = (source) => {
  api.appEvent({ kind: "tap", source, device: detectDevice(), device_id: deviceId() }).catch(() => {});
};

// First time the installed app is opened on this device.
export const reportInstallOnce = () => {
  if (localStorage.getItem(INSTALL_KEY)) return;
  api.appEvent({ kind: "install", device: detectDevice(), device_id: deviceId() })
    .then(() => localStorage.setItem(INSTALL_KEY, "1"))
    .catch(() => {});
};
